module.exports = __webpack_public_path__ + "img/764.9b81bb2c.jpg";